import styles from "./CreateYourOwnIntroView.module.css";
import CreateYourOwnTravelForm, {
  CreateYourOwnTravelFormData,
} from "./CreateYourOwnTravelForm";

interface CreateYourOwnIntroViewProps {
  travelDetails: CreateYourOwnTravelFormData | null;
  onContinue: (details: CreateYourOwnTravelFormData) => void;
  courseNames?: string[];
  isEu?: boolean;
}

function CreateYourOwnIntroView(props: CreateYourOwnIntroViewProps) {
  const { travelDetails, onContinue, courseNames = [], isEu = false } = props;

  return (
    <div className={styles.modalFormContainer}>
      <h2>Create your own holiday</h2>
      <p>
        Can't find the experience you're looking for? Tell us what you like and
        our golf specialists will help make it happen.
      </p>
      <CreateYourOwnTravelForm
        onContinue={onContinue}
        initialData={travelDetails || undefined}
        courseNames={courseNames}
        isEu={isEu}
      />
    </div>
  );
}

export default CreateYourOwnIntroView;
export { CreateYourOwnIntroView, type CreateYourOwnIntroViewProps };
